// extracted by mini-css-extract-plugin
module.exports = {"text_warning":"styles_text_warning__J4AOt"};